import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import type InvitationAdapter from 'uplisting-frontend/adapters/invitation';
import { InvitationValidation } from 'uplisting-frontend/validations';

export default class InvitationRepositoryService extends BaseRepositoryService<
  ModelRegistry['invitation']
> {
  recordName = 'invitation';
  implementMethods = [
    'buildChangeset',
    'createRecord',
    'destroyRecord',
    'save',
    'findAll',
    'unloadAll',
  ];

  validation = InvitationValidation;

  public async resend(invitation: ModelRegistry['invitation']): Promise<void> {
    try {
      const adapter = this.store.adapterFor('invitation') as InvitationAdapter;
      const payload = await adapter.resend(invitation.id);

      this.store.pushPayload(payload);
    } catch (err) {
      this.sentry.captureException(err, {
        tags: { repository: this.recordName, operation: 'resend' },
      });

      throw err;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/invitation': InvitationRepositoryService;
  }
}
